import React from 'react';
import { useConversation } from '../../../contexts/ConversationContext';
import { useTheme } from '../../../contexts/ThemeContext';

// Renders inside ConversationProvider so it can sum estimated_cost_usd
// from each assistant turn's metadata.turn_telemetry.
export const SessionCostChip: React.FC = () => {
  const { darkMode } = useTheme();
  const { state } = useConversation();
  let total = 0;
  state.messages.forEach((msg) => {
    if (msg.role !== 'assistant') return;
    const tt = (msg.metadata as any)?.turn_telemetry;
    if (tt?.estimated_cost_usd != null) total += Number(tt.estimated_cost_usd) || 0;
  });
  if (total === 0) return null;
  const fmt =
    total < 0.001
      ? `$${total.toFixed(5)}`
      : total < 0.01
        ? `$${total.toFixed(4)}`
        : total < 1
          ? `$${total.toFixed(3)}`
          : `$${total.toFixed(2)}`;
  return (
    <span
      className={`flex items-center gap-1 text-[11px] font-mono ${
        darkMode ? 'text-emerald-400' : 'text-emerald-700'
      }`}
      title={`Session total estimated cost: ${fmt}`}
    >
      💰 {fmt}
    </span>
  );
};
